import { paymentSchema, type CreatePaymentBody, type Payment } from '@klopotun/contracts';
import { apiRequest } from '../../../../shared/api/index.js';

const postPayment = (body: CreatePaymentBody): Promise<unknown> =>
  apiRequest<unknown>('/payments', { method: 'POST', body });

export const createPayment = async (body: CreatePaymentBody): Promise<Payment> =>
  paymentSchema.parse(await postPayment(body));
